import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { routesService } from "../services/services";
import { routesQueryKeys } from "../services/keys";

export const useGetRoutes = () => {
  return useQuery({
    queryKey: routesQueryKeys.list(),
    queryFn: () => routesService.getRoutes(),
    staleTime: 30 * 1000,
    refetchOnMount: true,
    gcTime: 5 * 60 * 1000,
  });
};

export const useGetRoute = (routeId: string) => {
  return useQuery({
    queryKey: routesQueryKeys.detail(routeId),
    queryFn: () => routesService.getRouteById(routeId),
    enabled: !!routeId,
    refetchOnMount: true,
  });
};

export const useOptimizeRoute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      leadIds: string[];
      name?: string;
      startLat?: number;
      startLng?: number;
      trafficAware?: boolean;
      geocodes?: Array<{ leadId: string; lat: number; lng: number }>;
    }) => routesService.optimizeRoute(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: routesQueryKeys.all(),
      });
    },
  });
};

export const useUpdateRoute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      routeId,
      data,
    }: {
      routeId: string;
      data: {
        status?: string;
        leadId?: string;
        visited?: boolean;
        skipped?: boolean;
        outcome?: 'refused' | 'no_sale' | 'sold';
      };
    }) => routesService.updateRoute(routeId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: routesQueryKeys.all(),
      });
    },
  });
};

export const useDeleteRoute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (routeId: string) => routesService.deleteRoute(routeId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: routesQueryKeys.all(),
      });
    },
  });
};
